import React, { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useModal } from '../hooks/useModal';
import { ParticipantWithAmount, useAddExpense } from '../hooks/mutations/useAddExpense';
import TransferConfirmModal from '../modals/TransferConfirmModal';
import { CurrencyCode } from '../constants/currencies';
import { formatCurrency } from '../utils/formatters';
import { toast } from 'react-hot-toast';
import { ArrowRight } from 'lucide-react';

interface OthersBalanceItemProps {
  myMemberId: string;
  memberNameMap: Map<string, string>;
  to: string;
  from: string;
  amount: number;
  currency: CurrencyCode;
}

const OthersBalanceItem: React.FC<OthersBalanceItemProps> = ({ 
  // myMemberId,
  memberNameMap,
  to,
  from,
  amount,
  currency,
}) => {
  const { id: groupId } = useParams<{ id: string }>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);
  const { showModal, closeModal } = useModal();
  const { mutateAsync: addExpense } = useAddExpense();

  const toName = memberNameMap.get(to);
  const fromName = memberNameMap.get(from);

  const handleConfirmTransfer = async () => {
    if (!groupId || isSubmittingRef.current) return;
    
    try {
      isSubmittingRef.current = true;
      setIsSubmitting(true);
      
      // 송금 정보 등록
      const receiverSet: ParticipantWithAmount[] = [{
        id: to,
        amount: Math.abs(amount),
        amountInCurrency:Math.abs(amount)
      }];
      
      await addExpense({
        groupId,
        title: '개인송금',
        amount: Math.abs(amount),
        amountInCurrency:Math.abs(amount),
        spentAt: new Date(new Date().toLocaleDateString('ko-kr', {year:'numeric', month:'2-digit', day:'2-digit'}).replace(/\./g,'').replace(/ /g,'').replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')),
        currency,
        exchangeRate: 1,
        paidBy: from,
        participants: receiverSet,
        isTransfer: true,
        transferTo: to,
      });
      
      // 모달 닫기
      closeModal();
    } catch (error: any) {
      toast.error(`오류: ${error.message}`);
    } finally {
      setIsSubmitting(false);
      isSubmittingRef.current = false;
    }
  };

  const openTransferModal = () => {
    showModal(
      <TransferConfirmModal 
        toName={toName}
        fromName={fromName} 
        channel={null}
        isToMe={null}
        onConfirm={handleConfirmTransfer}
        closeModal={closeModal}
        isSubmitting={isSubmitting}
      />
    );
  };

  return (
    <div className="flex items-center justify-between pt-2 not-last:pb-2">
      <div className='flex flex-col'>
        <div className="flex items-center gap-1 text-gray-800">
          <span className='font-semibold'>{fromName || "홍길동"}</span>
          <ArrowRight className='w-4 h-4' />
          <span className='font-semibold'>{toName || "이순신"}</span>
        </div>
        <span className='text-sm text-gray-800 font-mono-number'>{formatCurrency(Math.abs(amount), currency)}</span>
      </div>
      <div className='flex items-center gap-2'>
        <button 
          className='flex items-center justify-center px-2.5 py-1.5 rounded-lg font-bold bg-gray-50 border border-gray-100 text-gray-700 cursor-pointer'
          onClick={(e)=>{
            e.stopPropagation();
            openTransferModal();
          }}
        >
          완료처리
        </button>
      </div>
    </div>
  );
};

export default OthersBalanceItem; 